import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class SicCode extends BaseMessage {
    code;
    description;
    version;
}
__decorate([
    Field.string({
        description: 'Sic code of business',
        required: true,
    }),
    __metadata("design:type", String)
], SicCode.prototype, "code", void 0);
__decorate([
    Field.string({
        description: 'Sic code description of business',
        required: true,
    }),
    __metadata("design:type", String)
], SicCode.prototype, "description", void 0);
__decorate([
    Field.string({
        pattern: '^(2007)$',
        description: 'Sic code version',
        required: true,
    }),
    __metadata("design:type", String)
], SicCode.prototype, "version", void 0);
//# sourceMappingURL=SicCode.js.map